<ng-template [ngxPermissionsOnly]="['emailtemplates:can_get_emailtemplates_reports_sent']">
  <div class="box-row panel panel-default">
    <div class="panel-body text-center text-alpha">
      <div *ngIf="!isCountLoaded" class="whirl standard spinnermargin"></div>
      <ng-template [ngIf]="isCountLoaded">
        <div class="text-lg mo">{{emailSentCount}}</div>
        <p>Email Sent</p>
        <div class="mb-lg"></div>
      </ng-template>
    </div>
  </div>
</ng-template>